var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 181,
    viewBox: "0 0 216 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: 67.5,
    x2: 193,
    y2: 67.5,
    stroke: "#FFC400"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104.498,
    y1: 104.951,
    x2: 110.498,
    y2: 165.951,
    stroke: "#FF5619"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.27433,
    y1: 7.58198,
    x2: 71.2743,
    y2: 49.582,
    stroke: "#00AD5F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 68,
    r: 40,
    fill: "#FFC400"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 68,
    r: 15,
    fill: "#FFC400"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "#00AD5F",
    stroke: "#00AD5F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.245,
    cy: 169.946,
    r: 10,
    transform: "rotate(3.58975 112.245 169.946)",
    fill: "#FF5619"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_13977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.595 50.1016H89.6919C84.9434 50.1016 81.0977 53.953 81.0977 58.6958V73.6159C81.0977 78.3644 84.9491 82.2101 89.6919 82.2101H94.5891L100.555 89.1587C100.972 89.6444 101.555 89.8901 102.143 89.8901C102.732 89.8901 103.315 89.6444 103.732 89.1587L109.698 82.2101H114.595C119.343 82.2101 123.189 78.3587 123.189 73.6159V58.7016C123.189 53.953 119.343 50.1016 114.595 50.1016ZM120.903 73.6216C120.903 77.1016 118.075 79.9301 114.595 79.9301H109.698H108.646L107.961 80.7244L102.143 87.5073L96.3205 80.7301L95.6348 79.9358H94.5834H89.6862C86.2062 79.9358 83.3777 77.1073 83.3777 73.6273V58.7016C83.3777 55.2216 86.2062 52.393 89.6862 52.393H114.583C118.063 52.393 120.892 55.2216 120.892 58.7016V73.6216H120.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.828 59.2909C105.765 59.2909 105.702 59.2852 105.64 59.2852C103.96 59.2852 102.92 60.1594 102.548 60.5366L102.142 60.9537L101.737 60.5366C101.371 60.1594 100.331 59.2852 98.6453 59.2852C98.5824 59.2852 98.5196 59.2852 98.4567 59.2909C97.0167 59.348 95.6567 60.0223 94.731 61.1423C93.1767 63.0166 93.2453 65.2566 94.9253 67.7994C94.9481 67.8337 97.2281 71.108 102.148 73.8166C107.051 71.1137 109.348 67.828 109.365 67.8052C111.051 65.2566 111.114 63.0166 109.56 61.1423C108.628 60.0223 107.268 59.348 105.828 59.2909Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_13977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.2857,
    height: 40,
    fill: "white",
    transform: "translate(81 50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconGroup);
export default __webpack_public_path__ + "static/media/chat-icon-group.b9eee24f12536db5d2d70247131f412d.svg";
export { ForwardRef as ReactComponent };